import type { EMITS } from '@lib/components/CFileViewer/CFileViewer.types'

export default (
  pspdfkitInstance: any,
  emit: (eventType: (typeof EMITS)[number], payload: any) => void,
  initialPageIndex: number,
) => {
  let enteredPageAt = Date.now()
  let currentPageIndex = initialPageIndex

  emit('pdfPageEnter', { pageIndex: currentPageIndex })
  pspdfkitInstance.addEventListener('viewState.currentPageIndex.change', (newPageIndex: number) => {
    emit('pdfPageLeave', { pageIndex: currentPageIndex, durationInMs: Date.now() - enteredPageAt })
    emit('pdfPageEnter', { pageIndex: newPageIndex })
    currentPageIndex = newPageIndex
    enteredPageAt = Date.now()
  })
}
